import React from 'react';
import { withRouter } from 'react-router-dom';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SaveCancel, Label } from 'fw/components';
import { Form, TextBox, PhoneBox, EmailBox } from 'fw/forms';
import { CountryCombo, StateCombo } from 'areas/shared/controls';
import * as Notifications from 'fw/globals/Notifications';
import * as FormManager from 'fw/forms/form/FormManager';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';
import * as Help from 'modules/app/Help';


class SetupTab extends React.Component {

	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			loading: true,
			title: "",
			form: {}
		};
	}

	load = () => {
		// Nothing to load on this tab
	}

	get = () => {
		API.App.get('/appConfig/getSetup', {},
			{
				success: (r) => {
					this.setState((prevState, props) => ({
						loading: false,
						form: r.data
					}));
				}
			});
	}

	save = (rowVersion) => {
		const form = this.state.form;
		const me = this;

		let rq = {
			configId: form.configId,
			projectName: form.projectName,
			projectAcronym: form.projectAcronym,
			activityTitle: form.activityTitle,
			adminEmail: form.adminEmail,
			supportEmail: form.supportEmail,
			clientName: form.clientName,
		    clientPhone: form.clientPhone,
			clientFax: form.clientFax,
			address: form.address,
			address2: form.address2,
			city: form.city,
			zipCode: form.zipCode,
			countryCode: form.countryCode,
			stateCode: form.stateCode,
			sponsorSupportEmail: form.sponsorSupportEmail,
			rowVersion: rowVersion || form.rowVersion
        };

		API.App.post('/appConfig/saveSetup', rq,
			{
				success: (r) => {
					Notifications.success(r.message);
					me.get(r.data.entityId);
				},
				error: (r) => {
					if (r.data && r.data.rowVersion) {
						Modals.confirm(r.error.errorMessage,
							function () {
								me.save(r.data.rowVersion);
							},
							function () {
								me.get(r.data.entityId);
							}
						);
					} else {
						Notifications.error(r.error.errorMessage);
					}
				}
			});
	}

	cancel = () => {
		this.props.history.push('/');
	}

	handleSubmit = () => {
		this.save();
	}

	handleCancel = () => {
		const me = this;

		FormManager.checkUnsavedChanges(function () {
			me.cancel();
		})
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	setHelp = () => {
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();
	}

	componentDidMount() {
		this.get();
		this.setHelp();
	}

	render() {
		if (this.state.loading)
			return null;

		return (
			<React.Fragment>
				<Form
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}
					values={this.state.form}
					unsavedChangesWarning={true}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="projectName" required>Project Name</Label>
								<TextBox 
									name="projectName" 
									placeholder="Project Name"
									maxLength="50" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="projectAcronym" required>Project Acronym</Label>
								<TextBox 
									name="projectAcronym" 
									placeholder="Project Acronym"
									maxLength="50" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="adminEmail" required>Admin Email</Label>
								<EmailBox 
									name="adminEmail" 
									placeholder="Admin Email"
									maxLength="255" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="supportEmail" required>Support Email</Label>
								<EmailBox 
									name="supportEmail" 
									placeholder="Support Email"
									maxLength="255" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="adminSupportEmail" required>Corporate Members Support Email</Label>
								<EmailBox 
									name="sponsorSupportEmail" 
									placeholder="Corporate Members Support Email"
									maxLength="255" 
									required />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="clientName" required>Company Name</Label>
								<TextBox 
									name="clientName" 
									placeholder="Company Name"
									maxLength="66" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="clientPhone" required>Company Phone</Label>
								<PhoneBox name="clientPhone" maxLength="50" required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="clientFax">Company Fax</Label>
								<PhoneBox name="clientFax" maxLength="50" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="address" required>Address</Label>
								<TextBox 
									name="address" 
									placeholder="Address"
									maxLength="64" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="address2">Address 2</Label>
								<TextBox 
									name="address2" 
									placeholder="Address 2"
									maxLength="64" />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="city" required>City</Label>
								<TextBox 
									name="city" 
									placeholder="City"
									maxLength="30" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="zipCode" required>Zip Code</Label>
								<TextBox 
									name="zipCode" 
									placeholder="Zip Code"
									maxLength="12" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="stateCode" required>State</Label>
								<StateCombo 
									name="stateCode" 
									placeholder="State"
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="countryCode" required>Country</Label>
								<CountryCombo 
									name="countryCode" 
									placeholder="Country"
									required />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<SaveCancel onCancel={this.handleCancel} />
				</Form>
			</React.Fragment>)
	}
}

export default withRouter(SetupTab);



// WEBPACK FOOTER //
// ./src/areas/admin/appConfig/setup/SetupTab.js